import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedNumber, IntlProvider } from 'react-intl';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import { getCurrency } from '../../../utils';

import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';

import {
  Section,
  SectionInner,
  ContentTop,
  Description,
  HeroImageWrapper,
  Content,
  BodyTitle,
  Body,
  Subtitles,
  Subtitle,
  SubtitleList,
  Title,
  Text,
  SubtitleH2,
} from './SeminarHero.style';

/**
 * 「セミナー」画面 > 「セミナーのご案内」画面 > 一覧 > 各内容 > 詳細の内容 (左に画像、右にセミナータイトル、下に開催地域一覧)
 */
export const SeminarHero = ({ copy, locale, seminar }) => (
  <Section>
    {_.get(seminar, 'slug') && (
      <Helmet
        link={[
          makeCanonicalTagObj(locale, `/education/${seminar.slug}`),
          ...makeHreflangTagArr(seminar.recommendedSeminars.length ? seminar.recommendedSeminars[0].region : ['All'], `/education/${seminar.slug}`),
        ]}   
      />
    )}
    {_.get(seminar, 'metaData') && (
      <Helmet
        title={_.get(seminar.metaData, 'title')} 
        meta={[
          {
            name: 'description',
            content: _.get(seminar.metaData, 'description'),
          },
          {
            name: 'keyword',
            content: _.get(seminar.metaData, 'keyword'),
          },
          // TODO: OGP タグは一旦保留 (2020年01月07日)
          // {
          //   property: 'og:url',
          //   content: _.get(seminar.metaData, 'url'),
          // },
          // {
          //   property: 'og:type',
          //   content: _.get(seminar.metaData, 'type'),
          // },
          // {
          //   property: 'og:title',
          //   content: _.get(seminar.metaData, 'title'),
          // },
          // {
          //   property: 'og:image',
          //   content: _.get(seminar.metaData, 'image.file.url'),
          // },
          // {
          //   property: 'og:description',
          //   content: _.get(seminar.metaData, 'description'),
          // },
          // {
          //   property: 'og:site_name',
          //   content: _.get(seminar.metaData, 'siteName'),
          // },
        ]}
      />
    )}
    <SectionInner>
      <ContentTop>
        <HeroImageWrapper>
          {seminar.heroImage ? (
            <Image
              src={seminar.heroImage}
              options={{
                aspectRatio: 23 / 16,
                size: 575,
                objectFit: 'cover',
                w: '100%',
              }}
            />
          ) : (
            <Placeholder pb="calc(100% * 16 / 23)" w="100%" />
          )}
        </HeroImageWrapper>

        <Content>
          <Title>{seminar.name || <Placeholder h="110px" w="75%" />}</Title>
          <BodyTitle>{copy.audience || <Placeholder w="100px" h="25px" />}</BodyTitle>
          <Body>{seminar.targetAudience ? seminar.targetAudience.join(' / ') : <Placeholder h="25px" w="100%" />}</Body>
          <Description>{seminar.description || <Placeholder pb="35%" w="100%" />}</Description>
        </Content>
      </ContentTop>

      <Subtitles>
        <Subtitle>
          <Text>
            <SubtitleH2>{copy.capacity || <Placeholder w="150px" h="20px" />}</SubtitleH2>
            <p>{seminar.capacity || <Placeholder w="150px" h="50px" />}</p>
          </Text>
        </Subtitle>

        <Subtitle>
          <Text>
            <SubtitleH2>{copy.cost || <Placeholder w="150px" h="20px" />}</SubtitleH2>
            <p>
              {seminar.fee > -1 ? (
                <IntlProvider locale={locale.split('_')[0]}>
                  <FormattedNumber
                    value={seminar.fee}
                    style="currency" // eslint-disable-line
                    // maximumSignificantDigits={1}
                    currency={getCurrency(locale)}
                  />
                </IntlProvider>
              ) : (
                <Placeholder w="150px" h="50px" />
              )}
            </p>
          </Text>
        </Subtitle>

        <SubtitleList>
          <Text>
            <SubtitleH2>{copy.curriculum || <Placeholder w="150px" h="20px" />}</SubtitleH2>
            {seminar.curriculum ? (
              <ul>{seminar.curriculum.map(item => <li key={item}>{item}</li>)}</ul>
            ) : (
              <p>
                <Placeholder h="50px" w="150px" />
              </p>
            )}
          </Text>
        </SubtitleList>
      </Subtitles>
    </SectionInner>
  </Section>
);

SeminarHero.defaultProps = {
  seminar: {},
  copy: {},
};

SeminarHero.propTypes = {
  copy: PropTypes.shape(),
  locale: PropTypes.string.isRequired,
  seminar: PropTypes.shape(),
};

const mapState = state => ({
  copy: state.siteOptions.siteCopySeminarPage,
  locale: state.locale,
});

export const ConnectedSeminarHero = connect(mapState)(SeminarHero);



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/SeminarHero/SeminarHero.js